var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tip-dialog"},[_c('el-dialog',{attrs:{"title":"商品分组效果预览","visible":_vm.show,"before-close":_vm.close,"close-on-click-modal":false},on:{"update:visible":function($event){_vm.show=$event}}},[_c('img',{attrs:{"src":require("../../assets/img/pro-group/tip.png")}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }